import React, { useState, useContext } from "react";
import { MdOutlineClose } from "react-icons/md";
import { links } from "../../SocialMediaData";
import { FormContext } from "../../App";

const Form = () => {
  const { formOpen, setFormOpen } = useContext(FormContext);

  const [submit, setSubmit] = useState(false);
  const [formData, setFormData] = useState({
    "entry.856317015": "",
    "entry.2072097631": "",
    "entry.1100688263": "",
  });

  const handleInputData = (input) => (e) => {
    const { value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [input]: value,
    }));
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmit(true);

    let url = `https://docs.google.com/forms/u/0/d/e/1FAIpQLSemlTk441_6O2legzTaCsBx2aTZI85LShFDqm_8H5sfkysBeg/formResponse?entry.856317015=${formData["entry.856317015"]}&entry.2072097631=${formData["entry.2072097631"]}&entry.1100688263=${formData["entry.1100688263"]}`;

    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  return (
    <div className="contactFormWrapper">
      <div className="formheader">
        <div className="sm">
          {links.map((link, id) => {
            return (
              <div className="connectLink">
                <a href={link.link}>{link.icon}</a>
              </div>
            );
          })}
        </div>
        <div className="cross" onClick={() => setFormOpen(!formOpen)}>
          <MdOutlineClose />
        </div>
      </div>
      <div className="formcontact">
        {submit ? (
          <div className="afterForm">Thanks, will get back to you soon</div>
        ) : (
          <form onSubmit={handleSubmit} target="_self">
            <fieldset>
              <label htmlFor="entry.856317015">Name:</label>
              <input
                required
                type="text"
                name="entry.856317015"
                onChange={handleInputData("entry.856317015")}
                value={formData["entry.856317015"]}
                autoComplete={false}
              />
            </fieldset>

            <fieldset>
              <label htmlFor="entry.2072097631">E-mail:</label>
              <input
                required
                type="email"
                name="entry.2072097631"
                onChange={handleInputData("entry.2072097631")}
                value={formData["entry.2072097631"]}
                autoComplete={false}
              />
            </fieldset>

            <fieldset>
              <label htmlFor="entry.1100688263">Message:</label>
              <textarea
                required
                name="entry.1100688263"
                rows="4"
                cols="10"
                onChange={handleInputData("entry.1100688263")}
                value={formData["entry.1100688263"]}
                autoComplete={false}
              ></textarea>
            </fieldset>

            <button type="submit">Connect</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Form;
